import React, { useState } from "react";
import logo from "../images/logo.svg";
import cart from "../images/icon-cart.svg";
import avatar from "../images/image-avatar.png";
import CartItem from "./CartItem";
import menuIcon from "../images/icon-menu.svg";
import closeIcon from "../images/icon-close.svg";

const MobileNavbar = ({ items, deleteItem }) => {
    const [openCart, setOpenCart] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);

    const totalItemCount = items.reduce((total, item) => total + item.count, 0);

    return (
        <div className="h-[68px] w-full flex justify-between items-center border-b-[1px] border-[#E4E9F2] px-3">
            <div className="flex gap-4 items-center h-full ">
                <img
                    src={menuIcon}
                    alt="menu"
                    className="menuIcon"
                    onClick={() => setOpenMenu(!openMenu)}
                />

                {openMenu && (
                    <>
                        <div className="fixed z-30 bg-black bg-opacity-[75%] h-screen w-screen top-0 left-0"></div>
                        <div className="fixed z-50 w-[250px] bg-white top-0 left-0 h-full">
                            <img
                                src={closeIcon}
                                alt="close"
                                className="closeIcon ml-3 mt-6 mb-[50px]"
                                onClick={() => setOpenMenu(!openMenu)}
                            />
                            <nav className="flex flex-col gap-5 ml-3">
                                <a href="/" className="mobileLink">
                                    Collections
                                </a>
                                <a href="/" className="mobileLink">
                                    Men
                                </a>
                                <a href="/" className="mobileLink">
                                    Women
                                </a>
                                <a href="/" className="mobileLink">
                                    About
                                </a>
                                <a href="/" className="mobileLink">
                                    Contact
                                </a>
                            </nav>
                        </div>
                    </>
                )}

                <img
                    src={logo}
                    alt="logo"
                    className="border-b-4 border-transparent"
                />
            </div>
            <div className="flex items-center gap-[22px] border-b-4 border-transparent relative">
                <img
                    src={cart}
                    alt="cart"
                    className="cart-img"
                    onClick={() => setOpenCart(!openCart)}
                />
                {totalItemCount > 0 && (
                    <div className="absolute top-[-5px] left-[10px] bg-[#FF7E1B] w-[19px] h-[13px] flex items-center justify-center rounded-[6.5px] itemNumber">
                        {totalItemCount}
                    </div>
                )}
                {openCart && (
                    <div className="absolute top-[48px] z-50 right-0 bg-white w-[360px] h-full min-h-[256px] max-h-[500px] shadow-xl rounded-[10px] flex flex-col overflow-x-scroll">
                        <p className="border-b-[1px] discount text-[#1D2026] pl-6 py-6">
                            Cart
                        </p>
                        {items.length === 0 ? (
                            <div className="flex items-center justify-center h-full">
                                <p className="empty">Your cart is empty</p>
                            </div>
                        ) : (
                            <div className="flex flex-col items-center">
                                {items.map((item, index) => (
                                    <CartItem
                                        key={index}
                                        image={item.image}
                                        title={item.title}
                                        number={item.count}
                                        price={item.price}
                                        index={index}
                                        deleteItem={deleteItem}
                                    />
                                ))}
                                <button className="max-w-[312px] py-4 bg-[#FF7E1B] mb-8 rounded-[10px] w-full hover:bg-[#FFAB6A] buttonText">
                                    Checkout
                                </button>
                            </div>
                        )}
                    </div>
                )}
                <img
                    src={avatar}
                    alt="avatar"
                    className="h-[24px] w-[24px] avatar"
                />
            </div>
        </div>
    );
};

export default MobileNavbar;
